import { Injectable } from "@angular/core";
import { CultureService } from "../../../../shared/services/culture.service";
import { SelectedExamDetailService } from "../selected-exam-detail.service";
import { DistanceUnits } from "../../../../shared/enums/scheduling.enum";

@Injectable()
export class SitesService {


  constructor(
    private cultureService: CultureService,
    private selectedExamDetailService: SelectedExamDetailService
  ) {


  }

  /* Apply sorting based on user input */
  ApplySorting(propertyName: string) {
    if (propertyName == "Distance") {
      return function (a: any, b: any) {
        return a.location.distance - b.location.distance;
      }
    }
    else {
      return function (a: any, b: any) {
        return new Date(a.Testdate).getTime() -
          new Date(b.Testdate).getTime()
      }
    }
  }

  milesToKm(miles: number): number {
    return this.cultureService.convertMilesToKm(miles);
  }

  setUnit(unit: DistanceUnits) {
    this.selectedExamDetailService.setDistanceUnit(unit);
  }
}